<template>
  <!-- TODO Should display only in Desktop -->
  <div
    style="height: 100%"
    class="account-menu-layout"
    v-if="datasource && this.$vuetify.breakpoint.smAndUp"
  >
    <v-menu
      offset-y
      :min-width="menuWidth"
      :content-class="headerNavClass"
      left
      v-model="menuOpened"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="profile-button"
          :class="{
            'menu-active': menuOpened || routeActive,
          }"
          :ripple="false"
          :text="!mobileNav"
          :height="'100%'"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon :size="'32px'" left :color="buttonColor">mdi-account-outline</v-icon
          ><span :class="{ 'desktop-font-size': $vuetify.breakpoint.lgAndUp }" v-if="!mobileNav"
            >MY ACCOUNT</span
          >
        </v-btn>
      </template>
      <v-list flat class="nav-only-list">
        <!-- Going Through Children -->
        <v-list-item
          style="color: #002033 !important"
          class="menu-list-item"
          v-for="(item, index) in subpages"
          :key="index"
          :to="item.link.url"
        >
          <v-list-item-title>
            {{ item.name.text }}
          </v-list-item-title>
        </v-list-item>

        <!-- Logout -->
        <v-list-item style="color: #002033 !important" class="menu-list-item logout-item" @click="logout">
          <v-list-item-title>
            Logout
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { removeCorrelationId } from '../../../lib/UserSession.js';

export default {
  name: 'AccountMenu',
  data() {
    return {
      menuOpened: false,
      exit: null,
      routeActive: false,
    };
  },
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
    rendering: {
      type: Object,
    },
    data: {
      type: Object,
    },
  },
  mounted() {
    const path = this.$route.path.toLowerCase();
    if (path === '/profile' || path === '/changepassword') {
      this.routeActive = true;
    }
  },
  computed: {
    datasource() {
      let ds = this.fields.data && this.fields.data.datasource;
      if (process.env.VUE_APP_JssStandAlone === 'true') {
        const standaloneData = require('../../../../data/graphQL/AccountMenu.json');
        ds = standaloneData.datasource;
      }
      return ds;
    },
    subpages() {
      let pages = [];
      if (this.datasource && this.datasource.children) {
        this.datasource.children.forEach((element) => {
          pages.push(element);
        });
      }
      return pages;
    },
    buttonColor() {
      if (this.menuOpened || this.routeActive) {
        return '#00629B';
      }
      return '#002033';
    },
    headerNavClass() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return 'header-nav-menu-mobile';
        case 'sm':
          return 'header-nav-menu-tablet';
        case 'md':
          return 'header-nav-menu-tablet';
        case 'lg':
          return 'header-nav-menu-desktop';
        case 'xl':
          return 'header-nav-menu-desktop';
      }
      return 'header-nav-menu-desktop';
    },
    menuWidth() {
      if (this.$vuetify.breakpoint.xsOnly) {
        return '100%';
      }
      return '276px';
    },
    mobileNav() {
      if (this.$vuetify.breakpoint.xsOnly) {
        return true;
      }
      return false;
    },
  },
  methods: {
    async logout() {
      this.$store.dispatch('analytics', {
        actionName: 'Custom-Link-Click',
        entityChange: 'Logout',
      });
      await this.$auth.logout();

      // This will also remove the Correlation ID used for debugging
      removeCorrelationId();
    },
  },
};
</script>
<style lang="scss" scoped>
.v-btn {
  font-weight: map-get($font-weights, 'normal');
  border-bottom: 4px solid transparent;
}
.v-btn span {
  font-size: 1rem;
  color: map-deep-get($colors, 'blue-text', 'base');
}
.v-btn .desktop-font-size {
  font-size: 1.25rem;
}
.v-btn--text .v-btn__content {
  padding: 0 15px;
}
.v-btn:before {
  background: none;
}
.v-btn:hover span {
  color: map-deep-get($colors, 'blue-title', 'base');
}
.v-btn:hover:before {
  opacity: 0 !important;
}
.profile-button .v-icon {
  margin-top: 2px;
}
.profile-button:hover .v-icon {
  color: map-deep-get($colors, 'blue-title', 'base') !important;
}
.profile-button span {
  margin-top: 4px;
  letter-spacing: 0ch;
}
.hamburger-menu-icon {
  margin-right: 15px;
}
.menu-active {
  border-radius: 0;
  border-bottom: 4px solid map-deep-get($colors, 'blue-title', 'base');
}
.menu-active span {
  color: map-deep-get($colors, 'blue-title', 'base');
}
.v-icon--left {
  margin-right: 14px !important;
  margin-left: 0px !important;
}
.header-nav-menu-desktop {
  border-radius: 0;
  box-shadow: 1px 1px 4px rgba(2, 2, 2, 0.24);
  top: 73px !important;
}
.header-nav-menu-tablet {
  border-radius: 0;
  box-shadow: 1px 1px 4px rgba(2, 2, 2, 0.24);
  top: 55px !important;
}
.header-nav-menu-mobile {
  border-radius: 0;
  box-shadow: none;
  left: 0 !important;
  top: 55px !important;
  min-width: 100%;
}
.menu-list-item {
  padding: 0;
  margin: 0;
  height: 54px;
  text-decoration: none;
  align-items: stretch;
}
.v-list {
  padding-top: 0;
  padding-bottom: 0;
}
.v-list-item:hover .v-list-item__title {
  color: map-deep-get($colors, 'blue-title', 'base');
}
.v-list-item__title {
  margin: 0 10px;
}
.nav-only-list .v-list-item:last-of-type .v-list-item__title {
  margin: 0;
  padding: 0 10px;
}
.v-list-item--active {
  background: map-deep-get($colors, 'blue-title', 'base');
}
.v-list-item--active:before {
  background: none;
}

.v-list-item--active .v-list-item__title {
  color: map-deep-get($colors, 'white', 'base');
}
.v-list-item--active:hover .v-list-item__title {
  color: map-deep-get($colors, 'white', 'base');
}
.v-list-item__title {
  align-self: unset;
  border-bottom: 1px solid #dadada;
  display: flex;
  align-items: center;
  height: 100%;
}

*:focus {
  outline: none;
}
</style>
